module.exports = __webpack_public_path__ + "img/photo_size_select_small.c0daa0c6.svg";